var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', _vm._g({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "118",
      "height": "153"
    }
  }, _vm.$listeners), [_c('path', {
    attrs: {
      "fill": "#FFF",
      "stroke": "#FFF",
      "stroke-linecap": "square",
      "stroke-width": ".7",
      "d": "M111.907.212a.53.53 0 0 0-.47-.21l-.491.042c-.222-.07-12.368 1.706-12.368 1.706a.5.5 0 0 0-.471.518c.013.266.263.475.522.471l8.588-.742c-6.873 4.43-24.617 16.601-43.83 35.65C40.767 60.076 11.41 96.904.022 144.993c-.106.444.185.886.65.988q.097.02.191.02c.394 0 .75-.26.84-.643C13 97.659 42.139 61.1 64.592 38.83 84.044 19.537 101.96 7.354 108.5 3.16l-3.608 8.17a.49.49 0 0 0 .295.62q.097.037.195.037c.194 0 .38-.106.467-.284L111.95.707a.48.48 0 0 0-.043-.495"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }